<template>
  <div class="yx-statistics-xlcs-page main-layout">
    <CCollapseItem>
      <template slot="title-left"> 心理测试统计 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="导出" @click="exportExcel">
            <i class="iconfont icon-daochu3" :class="{ disabled: isExport }"></i>
          </div>
          <div class="opt-btn" title="统计分析" @click="handleShowStatistics">
            <i class="iconfont icon-statistics"></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="
            idList = [];
            pageGet(true);
          "
        ></table-btns>
      </div>
      <div class="div-scroll">
        <c-table
          :data="pageData"
          :tableColumns="tableColumns"
          :pagination="pageParams"
          @change="pageGet"
          @selectionChange="selectionChange"
          v-loading="pageLoading"
        >
        </c-table>
      </div>
    </el-card>
    <el-dialog
      custom-class="xlcs-statistics-dialog"
      :close-on-click-modal="false"
      title="心理测试统计分析"
      :visible.sync="dialogVisible"
      width="80%"
      @close="handleDialogClose"
    >
      <el-select
        v-model="collegeId"
        placeholder="请选择学院"
        @change="handleCollegeChange"
        clearable
        class="college-select"
      >
        <el-option
          v-for="item in collegeOptions"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <div class="chart-container">
        <xlcs-chart style="height: 100%" :value="chartData"></xlcs-chart>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MExcel from "@/mixins/MExcel.js";
import Configs from "./data/xlcs";
import CSearch from "@/components/CSearch/index.vue";
import CTable from "@/components/CTable/index.vue";
import TableBtns from "@/components/TableBtns/index.vue";
import xlcsChart from "../charts/xlcsChart";
import { getOrgOptions } from "@/libs/searchSelect.js";
let mPage = MPage({
  pagePath: "/welcome-forecast/psytest/result/welcomeListPage",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {
    studentName: "",
    collegeId: "",
    departmentId: "",
    majorId: "",
    classId: "",
    linkId: "",
  },
  pageExportPath: "/welcome-forecast/psytest/result/welcomeExportExcel",
  pageExportParams: {},
});
export default {
  mixins: [mPage],
  name: "",
  components: { CSearch, CTable, TableBtns, xlcsChart },
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      SUCCESS_CODE: "",
      idList: [],
      linkId: "",
      enrollmentYear: "", // 入学年份
      dialogVisible: false, // 控制统计分析弹框的显隐
      collegeOptions: [], // 学院选择数据
      collegeId: "",
      chartData: [],
      isExport: false, // 是否导出
      message: null,
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    this.enrollmentYear = this.$store.state.dic.ENROLLMENT_YEAR;
    getOrgOptions(this, { type: "college" }, 0, null);
    this.linkId = this.$route.params.linkId;
    this.pageParams.linkId = this.linkId;
    this.getColumns();
    this.getCollegeOptions(); // 获取学院下拉列表
  },
  mounted() {},
  methods: {
    //  修改列表参数
    pageGetBeforeFn(data) {
      switch (data.depression) {
        case "1":
          data.startScore = 0;
          data.endScore = 39;
          break;
        case "2":
          data.startScore = 40;
          data.endScore = 47;
          break;
        case "3":
          data.startScore = 48;
          data.endScore = 55;
          break;
        case "4":
          data.startScore = 56;
          data.endScore = 100;
          break;
      }
      delete data.depression;
    },
    //获取动态表头
    getColumns() {
      this.$http
        .get("/welcome-forecast/psytest/result/getWelcomeColumns")
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            let columns = res.data;
            this.options = columns;
            if (this.options.length) {
              this.titleId = this.options[0].id;
            }
            columns.forEach((item) => {
              this.tableColumns.push({
                label: item.name,
                prop: item.id,
                align: "center",
                minWidth: 120,
                show: true,
              });
            });
          } else {
            this.$message.error(`${res.msg}`);
          }
        });
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.studentId);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.idList = [];
      this.searchItems[1].options = [];
      this.searchItems[2].options = [];
      this.searchItems[3].options = [];
      this.pageParams = {
        studentName: "",
        collegeId: "",
        departmentId: "",
        majorId: "",
        classId: "",
        // linkId: this.linkId,
      };
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    exportExcel() {
      if (this.isExport) {
        return;
      } else {
        this.isExport = true;
        this.message = this.$message({
          message: "数据正在导出中，请稍候！",
          duration: 0,
          type: "warning",
          center: true,
        });
        let params = Object.assign({}, this.pageParams);
        if (!params.academicDegree)
          params.academicDegree = this._CURRENT_ACADEMIC;
        params.enrollmentYear = this._CURRENTYEAR[0].value;
        this.pageExportParams = params;
        if (this.idList.length) {
          this.pageExportParams.studentIdStr = this.idList.join();
        }
        this.pageExport();
      }
    },
    pageExportAfterFn() {
      this.isExport = false;
      this.message.close();
      this.message = null;
      this.refresh();
      this.pageExportParams = {};
    },
    // 获取所有院系
    getCollegeOptions() {
      this.$http
        .get("/account/sys/org/listByType?type=college")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.collegeOptions = res.data;
          } else {
            this.collegeOptions = [];
          }
        })
        .catch((err) => {
          this.collegeOptions = [];
        });
    },
    // 获取所有院系统计分析
    getXlcsStatistics(collegeId) {
      let params = {
        collegeId: collegeId || "",
        enrollmentYear: this.enrollmentYear,
      };
      this.$http
        .get("/welcome-forecast/psytest/result/welcomeStatistic", { params })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.chartData = res.data;
            console.log(this.handleData);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    handleCollegeChange(data) {
      this.getXlcsStatistics(data);
    },
    handleShowStatistics() {
      this.dialogVisible = true;
      this.getXlcsStatistics();
    },
    handleDialogClose() {
      this.collegeId = "";
      this.chartData = [];
    },
  },
};
</script>



